// Copyright (c) 2017 Deere & Company

import ReimbursementSummarySettings from '../../user/reimbursement-summary-settings/state-connector';

export default {
    component: ReimbursementSummarySettings,
    name: 'REIMBURSEMENT_SUMMARY',
    path: 'reimbursement-summary'
};



// WEBPACK FOOTER //
// ./src/routes/settings/reimbursement-summary.js